import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgFacialRecognitionFailed(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="facial-recognition-failed_svg__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={12}
        width={96}
        height={96}
      >
        <circle cx={60} cy={60} r={48} fill="#ECEFF1" />
      </mask>
      <g mask="url(#facial-recognition-failed_svg__a)">
        <circle cx={60} cy={60} r={48} fill="#F1F5F9" />
        <path
          d="M59.586 17.834c-.795-1.183-2.181-1.815-4.557-1.7-4.664.226-8.405 4.994-11.033 8.909-.997 1.486-1.828 2.724-2.477 3.28-.631.539-1.31 1.017-1.982 1.489-1.587 1.117-3.135 2.206-3.923 4.026a2.878 2.878 0 0 0-.134 1.86c.627 2.423 2.432 3.703 4.477 3.984.718 1.399 1.24 2.337 3.918 3.66 2.775 1.369 11.949 2.568 16.202 3.065 4.23.669 13.386 1.99 16.427 1.42 2.937-.55 3.692-1.313 4.761-2.466 2.046.281 4.129-.463 5.386-2.627a2.88 2.88 0 0 0 .373-1.828c-.267-1.965-1.464-3.431-2.691-4.935-.52-.636-1.044-1.28-1.506-1.97-.475-.709-.941-2.126-1.5-3.826C79.852 25.697 76.85 17.072 69.048 16c-4.342-.597-6.221-.856-9.463 1.834Z"
          fill="#0F172A"
        />
        <path
          d="M57.02 48.21h5.153l1.89 14.08a6.346 6.346 0 0 0 5.836 5.502c1.507.108 3.05.225 4.598.372 2.652.251 5.324.592 7.868 1.132 4.236.899 7.644 3.943 9.302 7.943 4.112 9.916 4.674 20.074 5.175 29.139.08 1.425.157 2.824.246 4.19H22.105c.09-1.366.167-2.765.246-4.19.501-9.065 1.063-19.223 5.175-29.139 1.659-4 5.066-7.044 9.302-7.943 2.629-.558 5.382-.902 8.122-1.156 1.463-.136 2.92-.246 4.344-.348a6.346 6.346 0 0 0 5.836-5.502l1.89-14.08Z"
          fill="#80CCB5"
        />
        <path
          d="M58.843 31.653c-.66-.459-1.298-.902-2.161-1.192-.71-.238-1.458.042-1.781.711-.34.705-.708 1.686-1.111 2.762-.456 1.217-.956 2.555-1.514 3.748-.897 1.921-1.744 3.177-2.398 3.975a2.177 2.177 0 0 0-2.081 3.764c.295.23.687.414 1.108.53.62 7.013 3.859 12.347 9.276 13.092 5.41.744 9.963-3.506 12.454-10.074.543.045 1.095-.024 1.524-.199a2.176 2.176 0 0 0-1.256-4.148c-.422-.943-.916-2.403-1.272-4.554-.214-1.3-.336-2.722-.446-4.017-.097-1.145-.186-2.19-.324-2.96-.13-.732-.775-1.203-1.523-1.165-.91.046-1.643.301-2.402.565-.655.227-1.328.461-2.15.574a3.807 3.807 0 0 1-2.028-.279c-.761-.33-1.347-.737-1.915-1.133Z"
          fill="#A6DBCB"
        />
        <path
          d="M62.825 45.183a.584.584 0 0 1 .625.54c.081 1.081-.3 1.986-.987 2.526-.686.539-1.61.658-2.472.29a.584.584 0 1 1 .458-1.074c.489.209.958.13 1.293-.134.334-.263.6-.765.544-1.522a.584.584 0 0 1 .539-.626ZM59.046 51.97a.584.584 0 0 0-.146-1.159c-1.36.171-2.34-.641-2.565-1.55a.584.584 0 0 0-1.133.28c.373 1.514 1.928 2.67 3.844 2.429Z"
          fill="#0F172A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.375 30.919c.462-.957 1.53-1.334 2.493-1.01.943.316 1.638.8 2.288 1.252l.02.013c.571.398 1.113.773 1.815 1.077a3.22 3.22 0 0 0 1.715.236c.758-.104 1.381-.319 2.039-.547l.023-.008c.747-.26 1.547-.537 2.54-.588 1.016-.052 1.941.599 2.128 1.646.142.796.233 1.862.329 2.987l.002.025c.11 1.3.23 2.699.44 3.972.302 1.824.702 3.127 1.064 4.022a2.76 2.76 0 0 1 1.109 5.316 3.79 3.79 0 0 1-1.35.254c-2.56 6.444-7.22 10.841-12.928 10.056-5.727-.787-9.03-6.309-9.741-13.234a3.59 3.59 0 0 1-.922-.505 2.76 2.76 0 0 1 2.221-4.89c.586-.764 1.315-1.903 2.088-3.557.546-1.17 1.038-2.484 1.495-3.706l.01-.023c.395-1.058.77-2.06 1.122-2.788Zm2.121.096c-.456-.153-.885.03-1.07.412-.325.675-.683 1.627-1.089 2.713l-.004.01c-.453 1.21-.96 2.566-1.528 3.78-.915 1.96-1.788 3.259-2.476 4.098l-.263.32-.388-.142a1.594 1.594 0 0 0-1.523 2.755c.223.173.542.328.906.429l.39.108.036.403c.611 6.92 3.77 11.877 8.774 12.565 4.995.687 9.37-3.221 11.828-9.704l.156-.411.439.037c.47.04.928-.024 1.255-.157a1.593 1.593 0 0 0-.918-3.037l-.459.094-.19-.426c-.446-.994-.954-2.503-1.316-4.698-.219-1.322-.342-2.764-.451-4.05l-.001-.012c-.099-1.156-.186-2.17-.317-2.907-.075-.417-.438-.71-.92-.685-.815.042-1.476.268-2.24.533l-.015.005c-.648.225-1.367.475-2.247.596a4.387 4.387 0 0 1-2.339-.322c-.814-.353-1.44-.788-2.003-1.18l-.014-.009c-.663-.462-1.238-.858-2.013-1.118Z"
          fill="#A6DBCB"
        />
      </g>
      <mask
        id="facial-recognition-failed_svg__b"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={12}
        width={96}
        height={96}
      >
        <circle cx={60} cy={60} r={48} fill="#F1F5F9" />
      </mask>
      <g mask="url(#facial-recognition-failed_svg__b)">
        <path
          d="M59.663 78.314c4.012-2.924 7.57-7.76 9.786-10.709.2.033.402.057.606.071 1.533.108 3.1.225 4.676.372 2.698.252 5.415.594 8.001 1.134 4.308.901 7.773 3.95 9.46 7.958 3.225 7.662 4.303 15.47 4.86 22.808 0 0-5.649 1.608-10.397.877-.594 4.093-1.039 6.139-1.93 9.701H34.438c-.89-3.562-1.335-5.608-1.929-9.701-4.748.731-10.403-.877-10.403-.877.558-7.338 1.636-15.145 4.861-22.808 1.687-4.008 5.152-7.057 9.46-7.958 2.673-.558 5.473-.903 8.259-1.158 1.488-.136 2.969-.245 4.417-.348.256-.018.508-.05.756-.097 2.215 2.964 5.782 7.811 9.805 10.735Z"
          fill="#78B441"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.292 67.936a199.637 199.637 0 0 0-4.55-.368c-.183-.01-.356-.04-.538-.068l-1.056.94c-2.103 2.858-5.137 6.918-8.516 9.553-3.399-2.645-6.442-6.724-8.545-9.592l-1.056-.92h-.019a7.78 7.78 0 0 1-.662.087 178.39 178.39 0 0 0-4.302.349c-.671.062-.672 1.23-.672 1.23s.164 4.283.999 5.95c.922 1.86 2.237 3.294 3.187 4.05.24.193.576.164.778-.059l3.456-3.778a.595.595 0 0 0-.029-.824.582.582 0 0 0-.816.029l-3.081 3.362a11.743 11.743 0 0 1-2.468-3.314c-.787-1.589-1.248-3.498-.835-5.542 1.296-.116 2.592-.213 3.86-.31.143-.01.287-.029.431-.048 2.103 2.887 5.425 7.441 9.188 10.329v9.292c0 .32.26.58.576.58a.58.58 0 0 0 .576-.58V78.99c3.716-2.858 7.009-7.344 9.121-10.231l.058-.078.288.029c1.353.097 2.726.204 4.109.33.412 2.044-.048 3.953-.836 5.542a11.925 11.925 0 0 1-2.467 3.314l-3.082-3.363a.573.573 0 0 0-.816-.029.586.586 0 0 0-.029.824l3.457 3.779a.564.564 0 0 0 .777.058c.95-.766 2.266-2.19 3.188-4.05.825-1.667 1.363-3.721.998-5.95-.097-.596-.227-.726-.672-1.23ZM23.342 100.029l.029-.555s.282.068.457.107c.585.137 1.412.312 2.375.468 1.801.282 4.069.486 6.181.233-.418-3.173-.72-6.463-.72-8.633 0-.322.263-.584.584-.584.321 0 .584.262.584.584 0 4.175 1.158 12.692 2.024 16.147.01.059.02.117.02.166.136.603.292 1.236.457 1.927l.244 1.168-1.304-.039-.147-1.129c-.72-2.978-1.138-4.983-1.645-8.449-2.258.263-4.623.049-6.463-.243a36.776 36.776 0 0 1-2.462-.477c-.097-.019-.195-.049-.273-.068l.059-.623ZM96.696 99.055s-.304.074-.492.117c-.629.15-1.519.341-2.556.511-1.938.31-4.367.533-6.63.256.45-3.474.775-7.077.775-9.454a.636.636 0 0 0-.628-.64.636.636 0 0 0-.628.64c0 4.114-1.006 12.066-1.886 16.383-.052.266-.115.532-.167.799-.042.181-.084.352-.115.501 0 .032-.01.074-.021.106-.157.683-.325 1.407-.513 2.186 0 .821 1.057.905 1.277 0 .22-.906.409-1.727.576-2.527.053-.245.105-.501.168-.767.377-1.801.68-3.56 1.026-5.958 2.42.287 4.975.053 6.955-.267 1.078-.17 2-.373 2.65-.522l.157-.032c.052-.011.125-.682.125-.682l-.073-.64v-.01Z"
          fill="#0F172A"
        />
      </g>
      <path
        d="M78.966 12.037c.825-.072 2.545-.018 3.422-.016.915 0 2.658-.058 3.53.025.956.09 1.84.585 2.458 1.375 1.02 1.321.884 2.413.884 4.014v3.725c0 .983.01 2.031-.014 3.02-.006.225-.174.338-.334.473-1.25.033-.91-.81-.907-1.889v-4.27c.002-.742.046-2.245-.09-2.92a2.816 2.816 0 0 0-.568-1.207 2.442 2.442 0 0 0-1.222-.816c-.66-.195-1.489-.137-2.173-.138a560.73 560.73 0 0 0-4.586.018c-.194-.012-.578-.097-.69-.3-.265-.492-.042-.82.29-1.094ZM36.086 12.049c.428-.059 1.45-.017 1.92-.023 1.535-.018 3.07.048 4.604-.025.476-.022.918.266.909.822-.015.807-1.199.587-1.716.595-1 .015-2.04-.01-3.042-.005-1.348.03-2.848-.262-3.895.865-.93 1.001-.776 2.423-.768 3.706 0 .862.077 6.016-.038 6.3a.599.599 0 0 1-.344.332c-.17.07-.39.035-.548-.051a.654.654 0 0 1-.325-.435c-.058-.263-.028-8.126.035-8.603a4.457 4.457 0 0 1 .62-1.75c.621-1.003 1.509-1.494 2.588-1.728ZM33.2 48.988c1.175-.04.884.742.882 1.66l-.003 3.87c-.002.642-.003 1.282.002 1.923.009 1.303.678 2.445 1.993 2.781.615.157 1.273.117 1.906.113 1.353-.009 2.706.009 4.058-.02.61-.012 1.639-.104 1.46.838-.053.282-.16.33-.383.497l-4.39.006c-.695 0-1.671.032-2.329-.014a3.797 3.797 0 0 1-2.64-1.308c-1.062-1.236-.939-2.47-.94-3.987v-2.813c.001-.99-.01-2.018.007-3.01.004-.27.17-.367.376-.536Z"
        fill="#0F172A"
        stroke="#0F172A"
        strokeWidth={0.2}
        strokeLinecap="round"
      />
      <path
        d="M85.456 62.526c3.828 0 6.93-3.015 6.93-6.734s-3.102-6.734-6.93-6.734c-3.827 0-6.93 3.015-6.93 6.734 0 3.72 3.103 6.734 6.93 6.734Z"
        fill="#78B441"
      />
      <mask
        id="facial-recognition-failed_svg__c"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={78}
        y={49}
        width={15}
        height={14}
      >
        <path d="M92.386 49.053h-13.86V62.52h13.86V49.053Z" fill="#fff" />
      </mask>
      <g mask="url(#facial-recognition-failed_svg__c)">
        <mask
          id="facial-recognition-failed_svg__d"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={78}
          y={49}
          width={15}
          height={14}
        >
          <path d="M92.386 49.053h-13.86V62.52h13.86V49.053Z" fill="#fff" />
        </mask>
        <g mask="url(#facial-recognition-failed_svg__d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.72 54.92a.662.662 0 0 0 0-.956.71.71 0 0 0-.982 0l-2.976 2.893-1.587-1.542a.71.71 0 0 0-.983 0 .662.662 0 0 0 0 .955l2.078 2.02a.71.71 0 0 0 .983 0l3.468-3.37Z"
            fill="#fff"
          />
        </g>
      </g>
      <path d="M85 64a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" fill="#E41E3F" />
      <path
        d="M88.325 58.102a.718.718 0 0 1 0 1.033.777.777 0 0 1-1.063 0l-1.987-1.931-1.988 1.931a.786.786 0 0 1-1.063 0 .74.74 0 0 1-.224-.52c0-.192.08-.378.225-.513l1.987-1.931-1.987-1.931a.702.702 0 0 1-.225-.52c0-.199.08-.378.225-.513a.786.786 0 0 1 1.063 0l1.987 1.931 1.987-1.931c.277-.276.78-.276 1.063 0a.718.718 0 0 1 0 1.033l-1.987 1.931 1.987 1.931Z"
        fill="#fff"
      />
    </svg>
  )
}
export default wrapIllustration(SvgFacialRecognitionFailed)
